import { Injectable } from '@angular/core';
import { AnnotationDraftCache } from '../ports/annotation-draft-cache.port';
import { AnnotationRow } from '../domain/types';

const KEY_PREFIX = 'claim-annotator:draft:';

/** Best-effort localStorage-backed crash cache for annotation drafts. */
@Injectable()
export class LocalStorageDraftCache implements AnnotationDraftCache {
  read(documentId: string): AnnotationRow[] | null {
    try {
      const raw = localStorage.getItem(KEY_PREFIX + documentId);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? (parsed as AnnotationRow[]) : null;
    } catch {
      return null;
    }
  }

  write(documentId: string, rows: readonly AnnotationRow[]): void {
    try {
      localStorage.setItem(KEY_PREFIX + documentId, JSON.stringify(rows));
    } catch {
      // Quota exceeded or private-mode: ignore; best-effort.
    }
  }

  clear(documentId: string): void {
    try {
      localStorage.removeItem(KEY_PREFIX + documentId);
    } catch {
      // ignore
    }
  }
}
